import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    pagingServiceConflicAlert,
    getServiceConflicAlertById,
    saveServiceConflicAlert,
    deleteServiceConflicAlert
} from 'app/services/ServiceConflicAlertService';
import { ServiceConflicAlert } from "app/common/Model/ServiceConflicAlert";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";

export default class ServiceConflicAlertStore {

    listAllServiceConflicAlert = [];
    searchServiceConflicAlert = new SearchObject();
    pageServiceConflicAlert = null;
    selectedServiceConflicAlert = null;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;
    openSyncStore=false

    constructor() {
        makeAutoObservable(this);
    }
    getAllServiceConflicAlert = async (unitType) => {
        if (this.listAllServiceConflicAlert?.length === 0 || this.recentlyUpdated) {
            const searchObjectForAll = {
                pageSize: 1000000,
                pageIndex: 1,
                unitType: unitType,
            };

            pagingServiceConflicAlert(searchObjectForAll)
                .then(({ data }) => {
                    this.listAllServiceConflicAlert = data?.content;
                    this.recentlyUpdated = false;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu thuốc có lỗi")
                })
        }
    }
    

    pagingServiceConflicAlert = async () => {
        return await pagingServiceConflicAlert(this.searchServiceConflicAlert)
            .then(({ data }) => {
                this.pageServiceConflicAlert = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi")
            })
    }

    handleChangeFormSearch = (searchServiceConflicAlert) => {
        this.searchServiceConflicAlert = checkSearchObject(this.searchServiceConflicAlert, searchServiceConflicAlert);
        this.pagingServiceConflicAlert();
    }

    handleOpenFormCreateOrEdit = (drugInteractionsId) => {
        if (Boolean(drugInteractionsId)) {
            getServiceConflicAlertById(drugInteractionsId).then(({ data }) => {
                this.selectedServiceConflicAlert = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedServiceConflicAlert = new ServiceConflicAlert();
            this.openFormCreateOrEdit = true;
        }
    }

    saveServiceConflicAlert = async (drugInteractions, { setSubmitting }) => {
        try {
          const { data } = await saveServiceConflicAlert(drugInteractions);
          if (data) {
            this.selectedServiceConflicAlert = null;
            this.pagingServiceConflicAlert();
            this.handleClosePopup();
            this.recentlyUpdated = true;
    
            toast.success("Lưu bản ghi thành công!");
          }
        } catch {
          toast.error("Lưu bản ghi thất bại!");
        } finally {
          setSubmitting(false);
        }
      };

    handleDelete = (drugInteractions) => {
        this.selectedServiceConflicAlert = { id: drugInteractions?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteServiceConflicAlert(this.selectedServiceConflicAlert?.id)
            .then(() => {
                if (this.searchServiceConflicAlert?.pageIndex > 1 && this.pageServiceConflicAlert?.content?.length === 1) {
                    this.searchServiceConflicAlert.pageIndex -= 1;
                }
                toast.success("Xóa bản ghi thành công!");
                this.handleClosePopup();
                this.pagingServiceConflicAlert();
                this.recentlyUpdated = true;
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa bản ghi có lỗi");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.searchServiceConflicAlert = new SearchObject();
        this.pageServiceConflicAlert = null;
        this.selectedServiceConflicAlert = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }
}